// Polyfill for React.use hook
import React from 'react';

if (!('use' in React)) {
  // @ts-ignore
  React.use = function use(promise: Promise<any>) {
    throw promise;
  };
}
